import styled from 'styled-components';

export const ButtonRow = styled.button`
  border: none;
  background-color: transparent;
  width: 100%;
`;
